module.exports = "/assets/data/65b1b3ec8c839977d11d48f709a10e55-ST10.data.json";